import React, { useState } from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { BarChart3, Download } from 'lucide-react';
import Loading from '../../components/loading';
import ErrorMessage from '../../components/errorMessage';
import ClinicalProductionFilters from './components/ClinicalProductionFilters';
import ClinicalProductionSummary from './components/ClinicalProductionSummary';
import ClinicalProductionGroupList from './components/ClinicalProductionGroupList';
import { useClinicalProductionScreen } from './hooks/useClinicalProductionScreen';

export default function ClinicalProductionWeb() {
  const {
    isLoading,
    error,
    selectedDate,
    setSelectedDate,
    selectedStatus,
    setSelectedStatus,
    selectedProfessionalId,
    setSelectedProfessionalId,
    groupBy,
    setGroupBy,
    summary,
    groups,
    hasHiddenItems,
    setShowAllItems,
    downloadProduction,
  } = useClinicalProductionScreen();

  const [showErrorMessage, setShowErrorMessage] = useState(true);

  return (
    <Paper elevation={0} sx={{ borderRadius: 4, p: 2, bgcolor: 'background.paper' }}>
      <Loading isToHidden={isLoading === false} />

      {error && showErrorMessage && (
        <ErrorMessage message={error} show={showErrorMessage} setShow={setShowErrorMessage} />
      )}

      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box sx={{ color: 'primary.main', display: 'flex' }}>
            <BarChart3 size={20} />
          </Box>
          <Typography variant="h6">Produção clínica</Typography>
        </Stack>

        <Button
          size="small"
          variant="outlined"
          startIcon={<Download size={16} />}
          onClick={downloadProduction}
        >
          Baixar
        </Button>
      </Stack>

      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        Valor dos procedimentos executados no período
      </Typography>

      <Box sx={{ mt: 2 }}>
        <ClinicalProductionFilters
          selectedDate={selectedDate}
          onChangeDate={setSelectedDate}
          selectedStatus={selectedStatus}
          onChangeStatus={setSelectedStatus}
          selectedProfessionalId={selectedProfessionalId}
          onChangeProfessionalId={setSelectedProfessionalId}
          groupBy={groupBy}
          onChangeGroupBy={setGroupBy}
        />

        <ClinicalProductionSummary summary={summary} />

        <ClinicalProductionGroupList
          groups={groups}
          proceduresCount={summary.proceduresCount}
          hasHiddenItems={hasHiddenItems}
          onShowAllItems={() => setShowAllItems(true)}
        />
      </Box>
    </Paper>
  );
}
